import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export interface ClassificationDTO {
  classificationId: number;
  description: string;
}

export interface BucketDTO {
  title: string;
  description: string;
  classifications: ClassificationDTO[];
}

export interface AssetBucketingDTO {
  headline: string;
  supportingText: string;
  buckets: BucketDTO[];
  unassignedClassifications: ClassificationDTO[];
  isDefaultAssetBucketingLayout: boolean;
  canEnableManagementStylesBucketing: boolean;
  enableManagementStylesBucketing: boolean;
}

const fetchAssetBucket = (): Promise<AssetBucketingDTO> =>
  authFetch('/Adviser/AssetBucketing/Index');

export const useAssetBucketQuery = (enabled = true) => {
  return useQuery(queryKeys.assetBucket(), () => fetchAssetBucket(), {
    cacheTime: 0,
    enabled,
  });
};
